import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadSessionListFailed, loadSessionListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import addSortQuery from '../../../utils/addSortQuery';
import { clearEmptyProp } from '../../../utils/utils';

export default function* loadSessionList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      offset = 0,
      filter,
      reverse_order: reverseOrder = false,
      sortedColumns = [],
    } = payload;
    let pool = {
      limit,
      offset,
      reverse_order: reverseOrder,
    };
    yield delay(200);
    if (typeof filter === 'object' && Object.keys(filter).length) {
      pool = { ...clearEmptyProp(filter), ...pool };
    }
    if (sortedColumns && Array.isArray(sortedColumns)) {
      pool = addSortQuery(sortedColumns, pool);
    }
    const url = `${BACKEND_URL}/api/v1/sessions`;
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadSessionListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadSessionListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadSessionListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
